module.exports = __webpack_public_path__ + "img/c07_unittechramchampion_Normal_ua.d736faba.webp";